import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "./AuthGuard";
import { roleGuard } from "./RoleGuard";

import {
    Dashboard,
    ListRequests,
    EditRequest,
    ViewRequest,
    NotFound,
    Affiliates,
    Brands,
    Countries,
    Users,
    Statistics,
    Global,
} from "@/views";
import { Role } from "@/models";
import { cookieService } from "@/services";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "dashboard",
        component: Dashboard,
        meta: { gtm: "Dashboard" },
    },
    {
        path: "/list",
        name: "list-requests",
        component: ListRequests,
        meta: { gtm: "Request List" },
    },
    {
        path: "/archives",
        name: "archives",
        component: ListRequests,
        meta: {
            gtm: "Request List",
        },
        props: { archives: true },
    },
    {
        path: "/requests/new",
        name: "NewUserRequest",
        component: EditRequest,
        meta: { gtm: "New request" },
    },
    {
        path: "/requests/:requestId/edit",
        name: "EditUserRequest",
        component: EditRequest,
        props: getRequestId,
    },
    {
        path: "/requests/:requestId/",
        name: "ViewUserRequest",
        component: ViewRequest,
        props: getRequestId,
    },
    {
        path: "/manage/users",
        name: "Users",
        component: Users,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Manage Users",
        },
    },
    {
        path: "/manage/affiliates",
        name: "Affiliates",
        component: Affiliates,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Manage Affiliates",
        },
    },
    {
        path: "/manage/brands",
        name: "Brands",
        component: Brands,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Manage Brands",
        },
    },
    {
        path: "/manage/countries",
        name: "Countries",
        component: Countries,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Manage Countries",
        },
    },
    {
        path: "/manage/global",
        name: "Global",
        component: Global,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Manage Global Settings",
        },
    },
    {
        path: "/statistics",
        name: "statistics",
        component: Statistics,
        meta: {
            roleLevelRequirement: Role.Admin,
            gtm: "Statistics Page - Export file",
        },
    },
    {
        path: "/auth",
        redirect: to => {
            const redirectPath = cookieService.getCookie("exp.source") || "/";
            cookieService.deleteCookie("exp.source");
            return {
                path: redirectPath,
                hash: "",
            };
        },
        gtm: "Authentification",
    },
    {
        path: "*",
        name: "not-found",
        component: NotFound,
        gtm: "Not found",
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});

function getRequestId(route: any): object {
    return {
        requestId: Number(route.params.requestId),
    };
}

router.beforeEach(authGuard);
router.beforeEach(roleGuard);

export default router;
